export class SetJobsFiltersLoadingStatus {
    public static readonly type = '[JobsPlacements] Set jobs filters loading status';
}
